import React from 'react';
import { ApIcon, colors } from '@alixpartners/ui-components';
import { Wrapper, Label, IconWrapper } from './DropdownItem.styles';

export const DropdownItem = ({
	children,
	single,
	disabled,
	small,
	selected,
	partial,
	suppressHover,
	label,
	searchQuery,
	onChange,
	value,
}) => {
	const getHighlightedName = name => {
		if (!searchQuery) {
			return name;
		}

		const index = name.toLowerCase().indexOf(searchQuery.toLowerCase());
		const before = name.slice(0, index);
		const searchValue = name.slice(index, index + searchQuery.length);
		const after = name.slice(index + searchQuery.length, name.length);

		return (
			<React.Fragment>
				{before}
				<span>{searchValue}</span>
				{after}
			</React.Fragment>
		);
	};

	return (
		<Wrapper
			isSelected={selected || partial}
			disabled={disabled}
			small={small}
			suppressHover={suppressHover}
			single={single}
			onClick={() => {
				if (!disabled) {
					onChange(value);
				}
			}}
		>
			<IconWrapper>
				{!single && (
					<ApIcon
						iconColor={
							disabled ? colors.grey3 : selected ? colors.grey7 : colors.grey5
						}
						iconName={
							partial
								? 'indeterminate_outlined'
								: selected
									? 'checkbox_outlined'
									: 'checkbox_blank_outlined'
						}
						iconSize={20}
					/>
				)}
				{single &&
					selected && (
						<ApIcon
							iconName="check"
							iconColor={disabled ? colors.grey3 : colors.grey7}
							iconSize={16}
						/>
					)}
			</IconWrapper>
			{children || <Label>{getHighlightedName(label)}</Label>}
		</Wrapper>
	);
};
